import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '=',
        directManagers: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        countries: '=',
        siteId: '='
    },
    template: `
            <div class="person01">
                <!--<div class="img todo">-->
                    <!--<img ng-src="assets/tmp/img02.jpg">-->
                <!--</div>-->
                <div class="txt">
                    <div class="alert alert-plain" ng-if="vm.user.isAnonymized">
                        {{ 'user.User data is anonymized. Admin users are able to restore the data' | translate}}
                    </div>
                    <div class="alert alert-info" ng-if="!vm.user.isAnonymized && vm.user.anonymizationDate">
                        {{ 'user.This account will be anonymized on { date }' | translate:vm.getAnonymizationDateParams() }}
                    </div>
                    <div class="heading01 type01">
                        <a class="btn discrete" ui-sref="authorized.user.employee.list()">{{ 'general.Back to list' | translate }}</a>
                        <h1>{{ vm.user.displayName }}</h1>
                    </div>
                    <div class="loader02" ng-if="vm.loading"></div>
                    <dl>
                        <dt>{{ 'user.Country' | translate }}</dt>
                        <dd>{{ vm.getCountryLabel(vm.user.country) }}</dd>
                        <dt>{{ 'user.Language' | translate }}</dt>
                        <dd>{{ vm.userLanguage }}</dd>
                        <dt>{{ 'user.Timezone' | translate }}</dt>
                        <dd>{{ vm.userTimezone }}</dd>
                        <dt>{{ 'user.Personal code' | translate }}</dt>
                        <dd>{{ vm.user.idCode }}</dd>
                        <dt>{{ 'user.Email' | translate }}</dt>
                        <dd>{{ vm.user.primaryEmail }}</dd>
                        <dt>{{ 'user.Phone' | translate }}</dt>
                        <dd>{{ vm.user.contactPhone }}</dd>
                        <dt>{{ 'user.Employees direct manager' | translate }}</dt>
                        <dd>{{ vm.directManagers }}</dd>
                        <dt>{{ 'general.Status' | translate }}</dt>
                        <dd>{{ vm.USER_STATUS_ENUM.LABELS[vm.user.status] }}</dd>
                        <dt>{{ 'general.Working since' | translate }}</dt>
                        <dd>{{ vm.MomentService.formatDate(vm.user.workingSince) }}</dd>
                        <dt>{{ 'general.Employee in sites' | translate }}</dt>
                        <dd>
                            {{ vm.employeeRoleSites }}<br />
                            <a class="btn edit" ng-if="vm.PrivilegeService.isCompanyAdmin()" ui-sref="authorized.manage.permissions.users.detail.sites({ id: vm.user.id })">
                                {{ 'user.Change employee privileges' | translate }}
                            </a>
                        </dd>
                        <dt>{{ 'user.Direct manager' | translate }}</dt>
                        <dd ng-if="vm.user.isDirectManager">
                            {{ 'general.Yes' | translate }}
                            <span ng-if="vm.user.hasMyEmployeeManagePrivilege">
                                ({{ 'user.Can add employees' | translate }})
                            </span>
                            <span ng-if="vm.user.hasAllLearnersReportViewPrivilege">
                                ({{ 'user.Allow to monitor learner progress for all site users' | translate }})
                            </span>
                        </dd>
                        <dd ng-if="!vm.user.isDirectManager">
                            {{ 'general.No' | translate }}
                        </dd>
                    </dl>
                </div>
            </div>
            <ul class="actions01">
                <li ng-if="vm.canManageUsers && !vm.user.isAnonymized">
                    <a ui-sref="authorized.user.employee.edit({ id: vm.user.id })"
                    class="btn secondary">{{ 'general.Edit' | translate }}</a>
                </li>
                <li ng-if="vm.canManageUsers && vm.user.status===vm.USER_STATUS_ENUM.KEYS.ACTIVE">
                    <a
                    class="btn secondary" ng-click="vm.deactivateUser()">{{ 'general.Deactivate user' | translate }}</a>
                </li>
                <li ng-if="vm.PrivilegeService.isCompanyAdmin() && vm.user.isAnonymized">
                    <a
                    class="btn secondary" ng-click="vm.deanonymizeUser()">{{ 'user.Deanonymize user' | translate }}</a>
                </li>
                <li ng-if="vm.PrivilegeService.isCompanyAdmin() && vm.user.status === vm.USER_STATUS_ENUM.KEYS.INACTIVE">
                    <a ng-if="vm.PrivilegeService.isCompanyAdmin()"
                    class="btn negative" ng-click="vm.deleteUser(vm.user.id)">{{ 'general.Delete account' | translate }}</a>
                </li>
            </ul>
            <user-employee-detail-drl-list can-manage="!vm.user.isAnonymized" user="vm.user" departments="vm.departments" roles="vm.roles" levels="vm.levels" />
            <user-employee-detail-skills can-manage="!vm.user.isAnonymized" ng-if="vm.TokenService.isSkillsModuleEnabled() && vm.PrivilegeService.canManageUserSkills()" user="vm.user" />
            <user-employee-detail-licences ng-if="vm.canManageLicencePoints && !vm.user.isAnonymized"  user="vm.user" />
            <user-employee-detail-training-needs user="vm.user"/>
            <user-employee-detail-courses-in-progress user="vm.user"/>
            <user-employee-detail-courses user="vm.user"/>
            <user-employee-detail-inactivity-periods-list can-manage="!vm.user.isAnonymized" user="vm.user" />
            <user-employee-detail-additional-materials user="vm.user" />
    `
})
export default class {
    constructor (lodash, USER_STATUS_ENUM, ROLE_COMPANY_PRIVILEGE_ENUM, COMPANY_LANGUAGE_ENUM, TIMEZONE_ENUM, $translate,
                 PrivilegeService, MomentService, UserManagerService, TokenService, UserResource, ModalService,
                 toastr, $state) {
        this.lodash = lodash;
        this.$translate = $translate;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ROLE_COMPANY_PRIVILEGE_ENUM = ROLE_COMPANY_PRIVILEGE_ENUM;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.TIMEZONE_ENUM = TIMEZONE_ENUM;
        this.PrivilegeService = PrivilegeService;
        this.MomentService = MomentService;
        this.canManageUsers = PrivilegeService.canManageUsers();
        this.canManageLicencePoints = PrivilegeService.canManageLicencePoints();
        this.UserManagerService = UserManagerService;
        this.TokenService = TokenService;
        this.UserResource = UserResource;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.$state = $state;
        this.loading = false;
    }

    $onInit () {
        this.directManagers = this
            .UserManagerService
            .getChosenManagers(this.user, this.directManagers)
            .map(manager => manager.displayName)
            .join(', ')
        ;
        this.employeeRoleSites = this.user.employeeRoleSites.map(site => site.name).join(', ');
        this.userLanguage = this.COMPANY_LANGUAGE_ENUM.LABELS[this.user.coursyLanguage];
        this.userTimezone = this.TIMEZONE_ENUM.LABELS[this.lodash.invert(this.TIMEZONE_ENUM.KEYS)[this.user.timezone]];
    }

    getCountryLabel (value) {
        const country = this.lodash.find(this.countries, { key: value });
        return country === undefined ? '' : country.label;
    }

    deactivateUser (id) {
        this.reloadUser(); // to avoid cached error values
        const user = this.user;
        return this.ModalService.open({
            template: `
                <modals-user-employee-inactivity-periods on-close="vm.$uibModalInstance.dismiss()" on-update="vm.update()"
                user="vm.user" inactivity-period-id="vm.inactivityPeriodId" class="wrapper"></modals-user-employee-inactivity-periods>
                `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.user = user;
                this.inactivityPeriodId = id;
                this.update = this.$uibModalInstance.close;
            }
        })
        .then(() => {
            this.reloadUser();
            this.toastr.success(this.$translate.instant('employee.Employee account deactivated'));
        });
    }

    deanonymizeUser () {
        this.loading = true;
        this.UserResource.deanonymizeEmployee({}, this.user).$promise.then(() => {
            this.toastr.success(this.$translate.instant('user.Employee deanonymized'));
            this.reloadUser();
            this.loading = false;
        }).catch(() => {
            this.loading = false;
        });
    }

    getAnonymizationDateParams () {
        return { date: this.MomentService.formatDate(this.user.anonymizationDate, 'YYYY-MM-DD') };
    }

    reloadUser () {
        this.UserResource.get({ id: this.user.id, expand: 'drlsWithValue,inactivityPeriods,drls,anonymizationDate' })
            .$promise.then((reloadedUser) => {
                this.user = reloadedUser;
            });
    }

    deleteUser (id) {
        if (this.loading) {
            return;
        }
        this.ModalService.confirm(
            this.$translate.instant('employee.deleteConfirmationMessage'),
            'medium',
            true)
            .then(() => {
                this.loading = true;
                this.UserResource.delete({ id }).$promise.then(() => {
                    this.$state.go('authorized.user.employee.list');
                    this.toastr.success(this.$translate.instant('employee.Employee account deleted'));
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/index.js